import o from "./ghl-ui.es1256.js";
import r from "./ghl-ui.es1257.js";
import e from "./ghl-ui.es422.js";
function p(t) {
  return typeof t.constructor == "function" && !e(t) ? o(r(t)) : {};
}
export {
  p as default
};
